import { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLiabilitiesSummary } from '../../api/collectionLiabilitiesApi';

function formatAmount(amount: number): string {
  return `${amount.toFixed(2).replace('.', ',')} zł`;
}

export default function LiabilitiesSummaryCallout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);

  useEffect(() => {
    getLiabilitiesSummary()
      .then((summary) => {
        setPendingCount(summary.pendingCount);
        setPendingAmount(summary.pendingAmount);
      })
      .catch(() => {});
  }, [location.pathname]);

  if (pendingCount <= 0) return null;

  return (
    <Box
      sx={(theme) => ({
        mt: 2,
        p: 2,
        borderRadius: 2,
        border: `1px solid ${theme.app.destructive}`,
      })}
    >
      <Box
        sx={(theme) => ({
          display: 'inline-block',
          px: 1,
          py: 0.25,
          mb: 1,
          borderRadius: 99,
          backgroundColor: theme.app.destructive,
        })}
      >
        <Typography variant="caption" sx={(theme) => ({ color: theme.app.destructiveForeground, fontWeight: 700 })}>
          {t('liabilitiesSummary.urgent')}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1.5 }}>
        {t('liabilitiesSummary.unpaidCount', { count: pendingCount })}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography variant="caption" color="text.secondary">
          {t('liabilitiesSummary.total')}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {formatAmount(pendingAmount)}
        </Typography>
      </Box>
      <Button
        fullWidth
        variant="contained"
        disableElevation
        onClick={() => navigate('/parent/execute-payment?selectAll=true')}
        sx={(theme) => ({
          backgroundColor: theme.app.primary,
          color: theme.app.primaryForeground,
          '&:hover': { backgroundColor: theme.app.primaryHover },
        })}
      >
        {t('liabilitiesSummary.pay')}
      </Button>
    </Box>
  );
}
